import { useQuery } from '@tanstack/react-query';
import { postApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry One post with its comments, files and links. */
export function usePost(
  jobId: number | null | undefined,
  postId: string | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.posts.detail(jobId ?? -1, postId ?? ''),
    queryFn: ({ signal }) =>
      postApiClient.getPostById(jobId!, postId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0 && !!postId,
    staleTime: 0,
    meta: { suppressErrorToast: true, errorContext: 'post detail' },
  });
}
